<gbc-breadcrumb [pageInfo]="pageInfo"></gbc-breadcrumb>
<app-edit-igrid-installation-wizard
  [initialCompanyId]="initialCompanyId"
  [initialFacilityId]="initialFacilityId"
  [installationId]="installationId"
>
</app-edit-igrid-installation-wizard>
